export default __webpack_public_path__ + "static/media/weddingEvent.c984975b.jpg";